import { useState } from 'react'

import { excelLogo, newWordLogo } from '@assets'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface DownloadDocumentProps {
	readonly docxUrl: string;
	readonly xlsxUrl: string;
	readonly dropdownSide: 'up' | 'down';
	readonly onDownload: (type: 'xlsx' | 'docx') => void;
	readonly customSize?: string | undefined;
}

export default function DownloadDocument({ docxUrl, xlsxUrl, dropdownSide, onDownload, customSize = 'p-2' }: DownloadDocumentProps) {
	const [isDownloadDropdownVisible, setIsDownloadDropdownVisible] = useState(false)

	return (
		<button
			className={ `flex relative items-center justify-center flex-shrink-0 bg-gray-100 border-gray-300 gap-3 text-gray-600 border
	transition-colors duration-300 hover:bg-gray-200 hover:text-gray-500 ${dropdownSide === 'down' ? 'hover:rounded-b-none' : 'hover:rounded-t-none'} rounded-md ${customSize} text-xs min-w-[140px]` }
			onMouseEnter={ () => {
				setIsDownloadDropdownVisible(true)
			} }
			onMouseLeave={ () => {
				setIsDownloadDropdownVisible(false)
			} }
		>
			<FontAwesomeIcon icon="download" className="w-3 h-3" />
			<div className="font-bold">Download file</div>

			{ isDownloadDropdownVisible
				? <div className={ `${dropdownSide === 'down' ? 'top-full rounded-b-md ease-down' : 'bottom-full rounded-t-md ease-up'} absolute bg-white outline outline-1 shadow-md outline-gray-300 flex flex-col z-[60] ${customSize.includes('w-full') ? 'w-full' : ''}` }>
					<a
						href={ xlsxUrl }
						target="_blank"
						className="flex items-center text-gray-600 gap-3 border-b border-gray-300
		transition-colors duration-300 hover:bg-gray-200 p-3 text-xs"
						rel="noreferrer"
						onClick={ () => {
							onDownload('xlsx')
						} }
					>
						<img
							src={ excelLogo }
							alt="xlsx"
							className="w-4 h-4" />
						<div>Export to <span className="font-bold">Excel</span></div>
					</a>
					<a
						href={ docxUrl }
						className="flex items-center text-gray-600 gap-3
		transition-colors duration-300 hover:bg-gray-200 p-3 text-xs"
						rel="noreferrer"
						target="_blank"
						onClick={ () => {
							onDownload('docx')
						} }
					>
						<img
							src={ newWordLogo }
							alt="docx"
							className="w-4 h-4" />
						<div>Export to <span className="font-bold">Word</span></div>
					</a>
				</div>
				: null }
		</button>
	)
}
